export function LogoMark({ size = 28, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className} aria-label="Aurum AI">
      <defs>
        <linearGradient id="aurumGrad" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F2D98B" />
          <stop offset="0.5" stopColor="#D6AE57" />
          <stop offset="1" stopColor="#9B742C" />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="46" height="46" rx="11" stroke="url(#aurumGrad)" strokeWidth="1.5" opacity="0.5" />
      {/* Ascending A formed by market-structure strokes */}
      <path d="M13 35 L24 12 L35 35" stroke="url(#aurumGrad)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <path d="M18 27 L30 27" stroke="url(#aurumGrad)" strokeWidth="2.4" strokeLinecap="round" />
      {/* signal node */}
      <circle cx="24" cy="12" r="3" fill="#F2D98B" />
    </svg>
  );
}

export function Logo({ size = 28, showText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} />
      {showText && (
        <span className="font-semibold tracking-tight text-[var(--text)] text-lg">
          AURUM<span className="aurum-gold-text font-bold"> AI</span>
        </span>
      )}
    </div>
  );
}
